




































import Vue from 'vue';
import Component from 'vue-class-component';
import { InjectReactive, Prop } from 'vue-property-decorator';

// Shared types
import { System } from '@coldtec/cos-types';

/**
 *  Component to add an item to the system's accordion.
 */
@Component
export default class SystemAccordionItem extends Vue {

    @InjectReactive('system')
    private system!: System;

    @Prop({ type: Boolean, required: true })
    private open!: boolean;

    @Prop({ type: String, required: true })
    private toggleTitle!: string;

    /**
     *  Holding the state highlighting.
     */
    private shouldHighlight = false;

    /**
     *
     *  Used to highlight the item for a moment.
     *
     *  @param duration The duration of the highlighting in ms (defaults to 750)
     *
     */
    public highlight(duration = 750): void {

        this.shouldHighlight = true;

        setTimeout(() => this.shouldHighlight = false, duration);

    }

}
